import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from "@angular/common/http";
import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";
import { Injectable } from "@angular/core";


@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return next.handle(request)
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    if (error.status == 401 || error.status == 402) {
                        return throwError(() => "Din inloggning har gått ut, vänligen ladda om sidan.");
                    }
                    if (error.status == 403) {
                        return throwError(() => "Du saknar behörighet för denna funktion.");
                    }
                    if ((error.status == 400 || error.status == 500) && error.error?.detail != null) {
                        return throwError(() => error.error.detail);
                    }
                    let errorMsg = error.error;
                    if (error.message) errorMsg = error.message;
                    if (error.error?.["message"]) errorMsg = error.error["message"];
                    if (error.error?.["errors"]) errorMsg = JSON.stringify(error.error["errors"]);
                    return throwError(() => errorMsg);
                })
            )
    }
}
